import { tw } from "@careinfo/tailwind";
import APIS from "../../constant/Endpoint";
import DateRangePicker from "../Reusable/DateRangeField";
import MultipleSelectField from "../Reusable/MultipleSelectField";
import RangePicker from "../Reusable/DateRangeField/RangePicker";

export default function Filter(props: any) {
  const { register, errors, setValue, getValues, clearErrors, watch } = props;
  return (
    <div
      className={tw`p-2 rounded-md space-y-2 bg-[#fefefe]`}
      style={{
        boxShadow: "0px 1px 6px 0px #00000040",
      }}
    >
      <div className={tw`grid grid-cols-3 gap-6`}>
        <MultipleSelectField
          label={"Party"}
          queryKey={"party"}
          register={register("party__in")}
          watch={watch}
          setValue={setValue}
          url={APIS.COA}
          errors={errors.party__in}
          value={[]}
          props={{
            is_group: false,
            children__isnull: true,
            party__isnull: false,
          }}
        />
        <RangePicker
          label={"Select Date Range"}
          setValue={setValue}
           name={"created__range"}
          getValues={getValues}
        />
      </div>
    </div>
  );
}
